import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowForward from '@mui/icons-material/ArrowForward';

const CnhTypeError = () => {
    return (
        <Box>
            <Typography variant={'h2'}>
                Conclusão
            </Typography>
            <Typography variant={'body1'} sx={{mb: '20px'}} color={'red'}>
                Ops, sua categoria não preenche nossos requisitos.
            </Typography>

            <Stack direction={'row'} justifyContent={'end'} sx={{mt: 5}}>
                <Button variant={'contained'} href={'https://marvel.com.br'}>
                    Finalizar
                    <ArrowForward fontSize={'small'} sx={{ml: 2}}/>
                </Button>
            </Stack>
        </Box>
    );
};

export default CnhTypeError;